export const SUPPORT_STATUSES = {
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  CLOSED: 'CLOSED',
  EXPIRED: 'EXPIRED',
}
